import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

import { EncrDecrService } from './../../services/encr-decr.service';
import { SoaImageService } from './../../services/soa-image.service';
import { ContactService } from './../../services/contact.service';

@Component({
  selector: 'app-email-files-factoring',
  templateUrl: './email-files-factoring.component.html',
  styleUrls: ['./email-files-factoring.component.css']
})

export class EmailFilesFactoringComponent implements OnInit {
  user_id: any='';
  folderid:any='';
  company_id: any='';
  APIKEY:any= '';
  emailModel: any = {};
  validFolder:boolean=false;
  btnDisable: boolean = false;
  pdfSrc: string = '';
  loaderMode:boolean=false;
  loaderMessage:boolean=false;
  rfolderid:any=0;
  folder_id_e:any=0;
  customer_id: any = 0;
  nonfactmode:any=1;
  mergeStatus: boolean = false;
  mergeActionStatus: boolean = false;

  /*code by 28feb*/
  assign_fact_check_css:any='block';
  constructor(private _router : Router, 
      private toastr: ToastrService,
      private _activatedroute: ActivatedRoute,
      private fb: FormBuilder, 
      private http: HttpClient,
      private EncrDecr: EncrDecrService,
      private _soaImage: SoaImageService,
      private _contact: ContactService,
   ) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');
 
    this._activatedroute.params.subscribe(params => {
      this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
      this.folder_id_e = params['id'];
    });
	this.getFolderInfo(this.folderid);
  }


  getFolderInfo(folderid) {
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      mobile_id: folderid,
    }

    this.rfolderid = this.EncrDecr.set(localStorage.getItem('key'), folderid);
    this._soaImage.getFolderInfo(folderModel).subscribe(
      res => {
      	this.pdfSrc=res.data.merge_pdf_path;

        this.loaderMode = false;
        if(res.data.assign_fact=='1' || res.data.assign_fact=='2'){
          this.nonfactmode = 0 ;
        }
        this.customer_id = res.data.customer_id;
        if (res.data.merge_pdf_path != '') {
          this.mergeStatus = true;
          this.mergeActionStatus = true;
        }
        //if (res.data.soa_email == 'No' && res.data.merge_pdf_path != '') {
          this.getCustomerEmail();
        //}
      },
    );
  }

  getCustomerEmail() {  
    this.loaderMode = true;
    const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      customer_id: this.customer_id,
    }

    this._contact.getContactEmailsByid(folderModel).subscribe(
      res => {  
        this.loaderMode = false;
        if(res.data.assign_fact=='3'){
          this.assign_fact_check_css='none';
        }
        
        this.emailModel = res.data;
      },
    );
  }

  
  onSubmitInfo()
  {
    this.loaderMode = true;
    this.loaderMessage = true;
  	this.btnDisable = true;

  	const folderModel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      email_info: this.emailModel,
      folder_id: this.folderid,
    }

    this._soaImage.sendEmailToCustomer(folderModel).subscribe(
      res => {
        this.loaderMode = false;
        this.loaderMessage = false;
        if(res.status==true){
          this.toastr.success(res.message, 'Success');
          if(folderModel.email_info.assign_fact=='3'){
            this._router.navigateByUrl('/mobile/mobile-list');
          }
          else{
            this._router.navigateByUrl('/mobile/factoring-invoice/' + this.folder_id_e);
          }

        } else {
          this.btnDisable = false;
          this.toastr.error(res.message, 'Error');
          //this._router.navigateByUrl('/mobile/factoring-invoice/' + this.folder_id_e);
        }
      },
    );
  }

omit_special_char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   //alert(k);
   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57)); 
}
omits_special_char(event)
{   
   var k;  
   k = event.charCode;  //         k = event.keyCode;  (Both can be used)
   return( k == 8 || k == 32 || (k >= 48 && k <= 57)); 
}

isNumberKey(evt)
{
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode != 46 && charCode > 31 
    && (charCode < 48 || charCode > 57))
      return false;

  return true;
}

}